<h2 *ngIf="data.multiSelect" mat-dialog-title i18n>Select Users</h2>
<h2 *ngIf="!data.multiSelect" mat-dialog-title i18n>Select a User</h2>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="start stretch">
    <pcp-users-container
      [users]="data.users"
      [canEdit]="data.canEdit"
      [multiSelect]="data.multiSelect"
      [(value)]="data.value"
    ></pcp-users-container>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="15px"
>
  <button mat-button mat-dialog-close i18n>Close</button>
</mat-dialog-actions>
